import React, { useState } from 'react';
import SelectMenu from '../common/forms/selectmenu';
import LabelInput from '../common/forms/Labelinput';
import DateLabelInput from '../common/forms/DateLabelInput';
import Button from '../common/ui/button';
import CancelButton from '../common/ui/cancelbutton';
import { MdEditSquare } from 'react-icons/md';
import { RiDeleteBin5Line } from 'react-icons/ri';
import NoFound from '../common/ui/NoFound';
import RadioLabelInput from "../common/forms/radiolabelinput";
import WarningModal from '../common/ui/warningmodel';

export default function AddExbondForm({
  formData,
  updateFormData,
  records,
  setRecords,
  resultantOptions,
  loadingResultants,
  sectionOptions,
  loadingSections,
  exbondExportOptions,
  customerOptions,
  loadingCustomers,
  biNumberOptions,
  loadingBINumber,
  onBINumberChange,
  materialOptions,
  loadingMaterials,
  onFetchWeightDuty,
  availableWeights,
}) {
  const [editIndex, setEditIndex] = useState(null);
  const dutypaidOptions = [
    { label: "Yes", value: true },
    { label: "No", value: false },
  ];
  const [warningVisible, setWarningVisible] = useState(false);
  const [warningMessage, setWarningMessage] = useState("");


  const getLabelFromOptions = (options, value) => {
    const found = options?.find((opt) => opt.value === value);
    return found ? found.label : value || "—";
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return `${day} ${monthNames[date.getMonth()]} ${date.getFullYear()}`;
  };

  const handleEditEntry = (index) => {
    const entry = records[index];
    Object.entries(entry).forEach(([key, value]) => updateFormData(key, value));
    setEditIndex(index);
  };

  const handleDeleteEntry = (index) => {
    const updated = records.filter((_, i) => i !== index);
    setRecords(updated);
    if (editIndex === index) setEditIndex(null);
  };

  const resetForm = () => {
    const fields = [
      'biNumber',
      'beNumber',
      'beDate',
      'section',
      'exbondExport',
      'resultant',
      'resultantShortCode',
      'resultantName',
      'material',
      'materialShortCode',
      'materialNameOnly',
      'dutyExbond',
      'dollar',
      'rate',
      'weight',
      'invoiceValue',
      'customer',
      'dutypaid',
    ];
    fields.forEach((field) => updateFormData(field, field === 'dutypaid' ? null : ''));
    setEditIndex(null);
  };
  const handleAddEntry = () => {
    const {
      biNumber, beNumber, beDate, section, exbondExport, resultant,
      material, dutyExbond, weight, invoiceValue, customer, dutypaid
    } = formData;

    if (!biNumber || !beNumber || !beDate || !section || !exbondExport || !resultant || !material || (dutyExbond === '' || dutyExbond === undefined) || (weight === '' || weight === undefined) || (invoiceValue === '' || invoiceValue === undefined) || dutypaid === null || !customer) {
      setWarningMessage("Please fill all required fields!");
      setWarningVisible(true);
      return;
    }

    const availableWeight = availableWeights[material];
    const enteredWeight = Number(weight);
    if (availableWeight !== undefined && enteredWeight > availableWeight) {

      setWarningMessage(`Entered weight (${enteredWeight} kg) exceeds available weight (${availableWeight} kg)!`);
      setWarningVisible(true);
      return;
    }

    const newRecord = { ...formData };

    if (editIndex !== null) {
      const updated = [...records];
      updated[editIndex] = newRecord;
      setRecords(updated);
    } else {
      setRecords([...records, newRecord]);
    }

    resetForm();
  };

  const formatLabel = (value) => {
    return value
      ? value
        .toLowerCase()
        .split(",")
        .map(part =>
          part
            .trim()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ")
        )
        .join(", ")
      : "";
  };

    const formatIndianNumber = (num) => {
    if (num === null || num === undefined || isNaN(num)) return "0";
    return Number(num).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  return (
    <div className="space-y-4 w-full">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-x-6 gap-y-4 items-start">
        {/* LEFT SIDE FORM */}
        <div className="lg:col-span-4 bg-white shadow-soft border border-gray-100 rounded p-5 space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <SelectMenu
              label="BI No."
              name="biNumber"
              value={formData.biNumber}
              onChange={(value) => {
                updateFormData("biNumber", value);
                onBINumberChange(value);
              }}
              options={biNumberOptions}
              loading={loadingBINumber}
              searchable
              required
              usePortal
            />
            <LabelInput
              label="BE No."
              type="text"
              name="beNumber"
              value={formData.beNumber}
              onChange={(e) => updateFormData('beNumber', e.target.value)}
              required
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <SelectMenu
              label="Material"
              name="material"
              value={formData.material}
              onChange={(v) => {
                const selected = materialOptions.find((opt) => opt.value === v);

                updateFormData("material", v);
                updateFormData("materialNameOnly", selected ? selected.nameOnly : "");
                updateFormData("materialShortCode", selected ? selected.label : "");

                if (v) {
                  onFetchWeightDuty(v);
                }
              }}
              options={materialOptions}
              loading={loadingMaterials}
              searchable
              required
              usePortal
              disabled={!formData.biNumber}
            />

            <SelectMenu
              label="Resultant"
              name="resultant"
              value={formData.resultant}
              onChange={(v) => {
                const selected = resultantOptions.find((opt) => opt.value === v);
                updateFormData("resultant", v);
                updateFormData("resultantName", selected ? selected.nameOnly : "");
                updateFormData("resultantShortCode", selected ? selected.label : "");
              }}
              options={resultantOptions}
              loading={loadingResultants}
              searchable
              required
              usePortal
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <DateLabelInput
              label="BE Date"
              name="beDate"
              type="date"
              value={formData.beDate}
              onChange={(e) => {
                const selectedDate = e.target.value;
                const inbondDate = formData.inbondBeDate;

                if (inbondDate && new Date(selectedDate) < new Date(inbondDate)) {
                  setWarningMessage("BE Date cannot be earlier than Inbond BE Date!");
                  setWarningVisible(true);

                  return;
                }

                updateFormData("beDate", selectedDate);
              }}
              required
              disabled={!formData.material}
            />
            <SelectMenu
              label="Section"
              name="section"
              value={formData.section}
              onChange={(v) => updateFormData('section', v)}
              options={sectionOptions.map(opt => ({
                ...opt,
                label: formatLabel(opt.label)
              }))}
              loading={loadingSections}
              searchable
              required
              usePortal
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <SelectMenu
              label="Exbond/Export"
              name="exbondExport"
              value={formData.exbondExport}
              onChange={(v) => updateFormData('exbondExport', v)}
              options={exbondExportOptions}
              required
              usePortal
            />

            <LabelInput
              label="Duty Ex-bond (₹)"
              type="number"
              name="dutyExbond"
              value={formData.dutyExbond}
              onChange={(e) => updateFormData('dutyExbond', e.target.value)}
              required
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <LabelInput
              label="Dollar (₹) (ER)"
              type="number"
              name="dollar"
              value={formData.dollar}
              onChange={(e) => updateFormData('dollar', e.target.value)}
            />
            <LabelInput
              label="Rate"
              type="number"
              name="rate"
              value={formData.rate}
              onChange={(e) => updateFormData('rate', e.target.value)}
            />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
            <div>
              <LabelInput
                label="Weight (kg)"
                type="number"
                name="weight"
                value={formData.weight}
                onChange={(e) => {
                  const enteredWeight = e.target.value;
                  updateFormData('weight', enteredWeight);

                  if (formData.material && enteredWeight) {
                    const availableWeight = availableWeights[formData.material];
                    const weightNum = Number(enteredWeight);

                    if (availableWeight !== undefined && weightNum > availableWeight) {
                      setWarningMessage(`Entered weight (${enteredWeight} kg) exceeds available weight (${availableWeight} kg)!`);
                      setWarningVisible(true);
                      return;
                    }
                  }
                }}
                required
              />
            </div>
            <LabelInput
              label="Invoice Value ($)"
              type="number"
              name="invoiceValue"
              value={formData.invoiceValue}
              onChange={(e) => updateFormData('invoiceValue', e.target.value)}
              required
            />
          </div>

          <RadioLabelInput
            label="Duty Paid"
            name="dutypaid"
            required={true}
            value={formData.dutypaid}
            onChange={(val) => updateFormData("dutypaid", val)}
            options={dutypaidOptions}
          />
          <SelectMenu
            label="Customer"
            name="customer"
            value={formData.customer}
            onChange={(v) => updateFormData('customer', v)}
            options={customerOptions.map(opt => ({
              ...opt,
              label: formatLabel(opt.label)
            }))}
            loading={loadingCustomers}
            searchable
            required
            usePortal
          />

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 pt-4">
            <Button onClick={handleAddEntry}>
              {editIndex !== null ? 'Update Entry' : 'Add Entry'}
            </Button>
            <CancelButton onClick={resetForm}>Reset</CancelButton>
          </div>
        </div>

        {/* RIGHT SIDE TABLE */}
        <div className="lg:col-span-8 space-y-2">
          {records.length > 0 ? (
            <div className="overflow-x-auto p-2">
              <table className="min-w-full text-[13px] border-collapse">
                <thead>
                  <tr>
                    <th className="text-left text-gray-700 font-semibold px-3 py-2 w-40">Field Name</th>
                    {records.map((_, idx) => (
                      <th key={idx} className="text-left text-gray-700 font-semibold px-3 py-1 border-l border-gray-200">
                        Record {idx + 1}
                        <div className="flex justify-start gap-2 mt-1">
                          <button onClick={() => handleEditEntry(idx)} className="text-green-600 hover:text-green-700" title="Edit"><MdEditSquare size={15} /></button>
                          <button onClick={() => handleDeleteEntry(idx)} className="text-red-500 hover:text-red-700" title="Delete"><RiDeleteBin5Line size={15} /></button>
                        </div>
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {/* rows... simplified for readability — same as original logic */}
                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">BI No.</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{getLabelFromOptions(biNumberOptions, r.biNumber)}</td>
                    ))}
                  </tr>

                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">BE No.</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{r.beNumber || "—"}</td>
                    ))}
                  </tr>

                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">BE Date</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{formatDate(r.beDate)}</td>
                    ))}
                  </tr>

                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Section</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{formatLabel(getLabelFromOptions(sectionOptions, r.section))}</td>
                    ))}
                  </tr>

                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Exbond/Export</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{formatLabel(r.exbondExport || "—")}</td>
                    ))}
                  </tr>

                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Resultant</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{r.resultantShortCode || "—"}</td>
                    ))}
                  </tr>

                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Material</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{r.materialShortCode || "—"}</td>
                    ))}
                  </tr>

                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Duty Ex-bond (₹)</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{formatIndianNumber(r.dutyExbond || "—")}</td>
                    ))}
                  </tr>
                   <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Dollar (₹)</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{formatIndianNumber(r.dollar || "—")}</td>
                    ))}
                  </tr>
                     <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Rate</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{formatIndianNumber(r.rate || "—")}</td>
                    ))}
                  </tr>


                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Weight (kg)</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{formatIndianNumber(r.weight || "—")}</td>
                    ))}
                  </tr>

                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Invoice Value ($)</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{formatIndianNumber(r.invoiceValue || "—")}</td>
                    ))}
                  </tr>

                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Duty Paid</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{r.dutypaid === true ? "Yes" : r.dutypaid === false ? "No" : "—"}</td>
                    ))}
                  </tr>

                  <tr className="border-t border-gray-100">
                    <td className="px-3 py-1.5 font-medium text-gray-700 bg-gray-50">Customer</td>
                    {records.map((r, i) => (
                      <td key={i} className="px-3 py-1.5 border-l text-left">{formatLabel(getLabelFromOptions(customerOptions, r.customer))}</td>
                    ))}
                  </tr>
                </tbody>
              </table>

              {/* Totals Section */}
              <div className="flex justify-end mt-4 gap-3 flex-wrap">
                <div className="border border-gray-200 text-gray-700 px-3 py-2 rounded text-sm font-semibold min-w-[160px] text-center shadow-sm">
                  Total Duty Ex-bond: ₹{formatIndianNumber(records.reduce((sum, r) => sum + (Number(r.dutyExbond) || 0), 0))}
                </div>
                <div className="border border-gray-200 text-gray-700 px-3 py-2 rounded text-sm font-semibold min-w-[160px] text-center shadow-sm">
                  Total Weight: {formatIndianNumber(records.reduce((sum, r) => sum + (Number(r.weight) || 0), 0))} kg
                </div>
              </div>
            </div>
          ) : (
            <NoFound />
          )}
        </div>
      </div>
      {warningVisible && (
        <WarningModal
          message={warningMessage}
          onClose={() => setWarningVisible(false)}
        />
      )}

    </div>
  );
}
